import { render, staticRenderFns } from "./groupsAdmin.vue?vue&type=template&id=030ee32a"
import script from "./groupsAdmin.vue?vue&type=script&lang=js"
export * from "./groupsAdmin.vue?vue&type=script&lang=js"
import style0 from "./groupsAdmin.vue?vue&type=style&index=0&id=030ee32a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports